export enum WalletTabsEnum {
    DEPOSIT = 'DEPOSIT',
    WITHDRAW = 'WITHDRAW',
    HISTORY = 'HISTORY',
}
